export default "__VITE_ASSET__495cefae__"